import React from 'react';
import classNames from 'classnames';

export enum TextType {
    TITLE = 'title',
    CAPTION = 'caption',
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    H4 = 'h4',
    P1 = 'p-1',
    P2 = 'p-2',
    P3 = 'p-3',
}

export enum TextSize {
    SM = 'SM',
    MD = 'MD',
    LG = 'LG',
}

const mapSizeToClassName = {
    [TextSize.SM]: 'is-sm',
    [TextSize.MD]: '',
    [TextSize.LG]: 'is-lg',
};

export type TextProps = {
    inline?: boolean;
    type?: TextType;
    isMedium?: boolean;
    noWrap?: boolean;
    isExtended?: boolean;
    isInherited?: boolean;
    isResponsive?: boolean;
    isOneLine?: boolean;
    extraClass?: string;
    html?: string;
    color?:
        | 'white'
        | 'var(--color-primary-01)'
        | 'var(--color-primary-02)'
        | 'var(--color-primary-03)'
        | 'var(--color-primary-04)'
        | 'var(--color-primary-05)'
        | 'var(--color-primary-06)';
    style?: any;
    size?: TextSize;
    /**
     * Defines which HTML tag to use
     */
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
    id?: string;
};

const Text: React.FC<React.PropsWithChildren<TextProps>> = (props) => {
    const {
        inline,
        type,
        color,
        isMedium,
        noWrap,
        isExtended,
        isInherited,
        extraClass,
        style,
        html,
        isResponsive = true,
        isOneLine,
        size = TextSize.MD,
        tag = 'span',
        id,
    } = props;
    const classnames = {
        block: classNames(
            typeof type !== 'undefined' && type,
            {
                'is-medium': isMedium,
                'has-no-wrap': noWrap,
                'is-extended': isExtended,
                'is-inherited': isInherited,
                [extraClass as string]: extraClass,
                'is-responsive': isResponsive,
                'is-one-line': isOneLine,
                [mapSizeToClassName[size]]: true,
            }
            // color && typeof color === 'string' ? color : null
        ),
    };

    const TagName = tag as React.ElementType;
    let displayStyle: React.CSSProperties = {};
    if (inline && tag !== 'span') {
        displayStyle = {
            display: 'inline',
        };
    }
    if (!inline && tag === 'span') {
        displayStyle = {
            display: 'block',
        };
    }

    const styles = Object.assign({ color }, displayStyle, style);
    return (
        <TagName
            className={classnames.block}
            style={styles}
            dangerouslySetInnerHTML={
                html
                    ? {
                          __html: html,
                      }
                    : undefined
            }
            id={id}
        >
            {props.children}
        </TagName>
    );
};

export default Text;
